import React, { useState, useEffect } from "react";

const DynamicContent = ({ content }) => {
  const [description, setDescription] = useState(
    "<p>No Content Page Found</p>"
  );

  useEffect(() => {
    if (content) {
      try {
        const parsedContent = JSON.parse(content);
        setDescription(
          parsedContent[0]?.description || "<p>No Content Page Found</p>"
        );
      } catch (error) {
        console.error("Error parsing content:", error);
        setDescription("<p>No Content Page Found</p>");
      }
    } else {
      setDescription("<p>No Content Page Found</p>");
    }


  }, [content]);

  const formatTextChoice = (text) => {
    //return useTextFormatter(text);
    if (text === "") {
      return "";
    } else {
      const raw = text.replace(/\n/g, "<br />");

      return raw;
    }
    // const formatted = useMemo(() => {
    // if (!text) return "";

    // }, [text]);

    // return formatted;
  };

  return (
    <section className="checkout py-80">
      <div className="container container-md">
        <div
          dangerouslySetInnerHTML={{
            __html: formatTextChoice(description),
          }}
        ></div>
        
        {/* <h6 className="text-xl mb-24">Dynamic Content</h6>
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting,
          remaining essentially unchanged. It was popularised in the 1960s with
          the release of Letraset sheets containing Lorem Ipsum passages, and
          more recently with desktop publishing software like Aldus PageMaker
          including versions of Lorem Ipsum
        </p>
        <span className="mb-24">
          You Can Order Delivery Via This Link :{" "}
          <a href="www.pinkpeonyshopsg.com">www.pinkpeonyshopsg.com</a>
        </span>

        <p
          dangerouslySetInnerHTML={{
            __html:
              formatTextChoice(`ESTIMATED ARRIVAL FOR ALL ORDERS : BETWEEN 2 to 5 BUSINESS DAYS  FROM DATE OF PURCHASE\n
                    •⁠  ⁠IF YOU ARE NOT AGREEABLE TO THE TERMS OF PURCHASE PLEASE DO NOT PROCEED TO MAKE PAYMENT. ALL SALES ARE NON-REFUNDABLE AND NON-RETURNABLE*\n
                    Feel free to contact us with any question regarding our terms and conditions. Email to : idmartsg_cs@gmail.com`),
          }}
        ></p> */}
      </div>
    </section>
  );
};

export default DynamicContent;
